import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md bg-[#121212] border border-white/10 rounded-xl p-8" data-testid="forgot-password-form">
        <div className="flex justify-center mb-6"><Logo /></div>
        <h1 className="font-heading font-bold text-white text-xl text-center mb-1">Forgot your password?</h1>
        <p className="text-gray-400 text-sm text-center mb-8">
          Enter your account email and we'll send you a reset link.
        </p>
        {sent ? (
          <p className="text-[#34D399] text-sm text-center bg-[#34D399]/10 border border-[#34D399]/20 rounded p-4"
            data-testid="forgot-password-sent">
            If that email exists, a reset link is on its way. It expires in 1 hour — check your inbox.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-gray-300">Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-password-email" className="mt-1.5 bg-[#1A1A1A] border-white/10 text-white" />
            </div>
            {error && <p className="text-red-400 text-sm" data-testid="forgot-password-error">{error}</p>}
            <Button type="submit" disabled={busy} data-testid="forgot-password-submit"
              className="w-full bg-[#7C3AED] text-white font-bold hover:bg-[#6b2fd6]">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="text-center mt-6">
          <Link to="/login" className="font-mono text-xs text-gray-500 hover:text-[#00E5FF] transition-colors">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
